module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "radio-player"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "controls"
  }, [_c('div', {
    staticClass: "control play icon",
    on: {
      "click": _vm.togglePlaying
    }
  }, [(!_vm.playing) ? _c('span', {
    staticClass: "fa fa-play"
  }) : _c('span', {
    staticClass: "fa fa-pause"
  })]), _vm._v(" "), _c('div', {
    staticClass: "control play-time"
  }, [_c('Timer', {
    attrs: {
      "timesince": _vm.playtime,
      "countdown": false,
      "shouldtick": false
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "control sound"
  }, [_c('div', {
    staticClass: "icon",
    on: {
      "click": _vm.toggleMute
    }
  }, [(!_vm.muted) ? _c('div', [_c('span', {
    staticClass: "fa fa-volume-up"
  })]) : _c('div', [_c('span', {
    staticClass: "fa fa-volume-off"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "volume-slide",
    on: {
      "click": _vm.updateVolume
    }
  }, [_c('div', {
    staticClass: "volume-slide-inner",
    style: ({
      width: ((this.volume) + "%")
    })
  })])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('audio', {
    attrs: {
      "id": "radio_stream",
      "msAudioCategory": "backgroundCapableMedia"
    }
  }, [_c('source', {
    attrs: {
      "src": "https://radiostream.madnight.co.uk/;",
      "type": "audio/mpeg"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3b518248"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/globals/Player.vue
// module id = 272
// module chunks = 1